var _circle, _circle2, _g, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 742,
    height: 860,
    viewBox: "0 0 742 860",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 136.5,
    cy: 146.5,
    r: 30.5,
    fill: "url(#paint0_linear)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 768,
    cy: 705,
    r: 155,
    fill: "url(#paint1_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 382.006,
    cy: 378,
    r: 182,
    fill: "url(#paint2_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.705 399.276C410.042 397.913 406.801 399.239 404.223 400.565C402.161 401.633 400.946 403.806 401.093 406.089C401.425 411.797 401.977 417.211 402.493 421.704C403.376 429.106 400.541 436.435 394.98 441.37C384.631 450.503 368.758 464.24 365.554 465.64C363.16 466.671 359.109 470.464 356.789 474.736C356.31 475.62 355.905 476.504 355.574 477.388C354.359 480.444 356.679 483.722 359.956 483.685L370.01 483.575C372.552 483.538 374.688 481.623 374.909 479.082C374.909 479.082 374.945 471.385 380.506 467.555C391.334 460.115 422.674 435.367 422.674 435.367L426.578 427.781C429.082 422.846 427.756 416.843 423.411 413.455C423.374 413.418 414.535 407.047 410.705 399.276Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277.609 403.364C275.547 415.296 273.522 426.971 272.896 430.764C271.459 439.455 264.204 459.784 258.385 463.43C255.145 465.456 251.499 470.575 248.847 474.773C247.19 477.425 249.105 480.85 252.198 480.85H261.774C263.91 480.85 265.604 479.119 265.604 477.019V476.283C265.604 473.705 266.893 471.274 269.029 469.801L272.233 467.592C275.473 465.382 277.794 462.067 278.788 458.311L286.669 428.628L299.89 397.03C292.341 399.018 284.091 401.338 277.609 403.364Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M540.081 369.114C534.336 355.672 538.571 333.17 517.395 315.235C502.259 302.382 483.072 305.291 480.126 305.844C479.868 305.881 479.61 305.844 479.389 305.66C466.278 295.827 446.097 297.889 391.186 297.926C342.758 297.963 335.613 282.753 299.89 264.192C271.128 249.276 227.966 248.135 199.093 243.016C198.283 242.868 197.693 243.789 198.172 244.489L208.226 259.257C208.373 259.441 208.41 259.662 208.373 259.92C207.858 263.676 203.807 296.674 211.504 329.745C212.203 332.765 215.776 334.238 218.869 334.459C222.847 334.717 231.096 331.071 232.753 326.504C234.19 322.527 232.532 319.838 231.833 318.955C231.649 318.734 231.575 318.402 231.685 318.108C232.569 315.235 237.394 300.467 245.459 293.028C249.841 288.977 249.805 278.996 249.915 278.665C250.541 276.418 250.578 284.152 250.946 286.399C253.966 303.634 265.862 319.286 268.292 322.306C268.55 322.601 268.55 323.042 268.329 323.374C267.003 325.399 262.547 332.802 262.547 341.162C262.547 351.621 267.74 358.25 268.255 358.839C268.292 358.876 268.292 358.876 268.329 358.913C273.19 363.222 272.233 371.066 266.451 374.086C257.354 378.837 245.901 386.861 238.719 395C229.918 404.944 234.447 437.024 236.878 450.061C237.062 451.093 238.572 451.093 238.719 450.025C240.561 438.129 245.79 410.324 254.997 402.885C269.471 391.174 297.902 384.398 306.225 381.046C312.485 378.542 315.947 374.454 316.463 369.114C317.015 363.479 308.913 353.646 310.46 349.08C310.46 349.08 308.729 356.003 297.828 367.862C297.754 367.972 296.907 372.576 296.907 372.576C296.576 374.38 295.471 375.927 293.851 376.774C293.04 377.216 292.157 377.658 291.273 378.137C288.253 379.647 286.411 378.468 283.87 376.259L283.833 376.222C282.25 374.822 281.329 372.834 281.292 370.698L281.624 333.17C281.624 332.949 281.55 320.28 281.55 320.28C281.55 320.28 286.448 321.68 287.516 322.674C287.921 323.042 288.511 323.006 288.879 322.601L289.468 321.938C289.579 321.827 289.652 321.68 289.689 321.533L291.825 312.362C292.009 311.589 292.967 311.368 293.482 311.957L297.018 316.192C297.055 316.229 297.091 316.266 297.091 316.303L299.633 320.649C299.633 320.649 331.231 314.83 354.874 331.181C354.911 331.218 354.911 331.218 354.948 331.255L372.036 347.054C377.45 352.026 384.778 354.383 392.07 353.389L417.887 349.411C417.923 349.411 417.923 349.411 417.96 349.411C423.116 348.159 428.53 348.638 433.354 350.811L437.516 352.652C442.119 354.678 445.949 358.102 448.491 362.375C448.896 363.037 449.853 362.964 450.148 362.264L453.831 353.794C454.088 353.168 454.236 352.836 454.236 352.836L453.831 353.794C452.726 356.556 451.51 375.338 458.397 388.191C473.497 416.364 496.993 424.392 497.066 424.687L507.378 450.798C507.415 450.945 507.415 451.093 507.378 451.24L506.899 452.971C505.389 458.642 501.559 463.467 496.33 466.192L491.027 468.991C490.842 469.101 490.658 469.249 490.585 469.47L486.976 478.529C485.981 480.997 487.823 483.685 490.474 483.685H499.166C501.964 483.685 504.469 481.991 505.537 479.376C507.12 475.436 510.214 472.305 514.118 470.722C517.653 469.286 521.262 467.297 520.489 465.566C513.123 449.104 511.871 418.353 510.914 409.404C510.508 405.794 509.072 402.369 506.715 399.571L489.738 379.463C484.14 372.87 482.262 363.884 484.692 355.598C487.012 347.754 489.112 337.295 488.044 327.388C487.97 326.541 488.927 326.026 489.553 326.578C493.826 330.113 504.616 340.094 510.877 355.34C518.205 373.128 517.027 381.856 533.01 395.299C546.821 406.899 569.286 409.183 578.014 409.625C578.971 409.661 579.376 408.409 578.566 407.894C570.243 402.848 548.073 387.749 540.081 369.114Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.00585938,
    y: 0,
    width: 764,
    height: 764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 159.5,
    y1: 216,
    x2: 106,
    y2: 77.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 884.885,
    y1: 1058.2,
    x2: 613,
    y2: 354.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 432.006,
    y1: 552.5,
    x2: 295.006,
    y2: 133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder2);
export default __webpack_public_path__ + "static/media/placeholder2.06ca4b0c.svg";
export { ForwardRef as ReactComponent };